<div class="loader-shell" aria-live="polite" aria-busy="true">
  <div class="loader-ring" aria-hidden="true"></div>
  <div class="loader-text">Loading...</div>
</div>
